import { UnitStatus } from '../api';
import { UNIT_STATUS_HELP, UNIT_STATUS_LABEL } from '../format';

// Status of the tracker itself (not the vehicle's driving state): colour plus a word.
export function UnitStatusPill({ status }: { status: UnitStatus }) {
  return <span className={`chip unit-${status}`} title={UNIT_STATUS_HELP[status]}>{UNIT_STATUS_LABEL[status]}</span>;
}
